import { Grid, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

// Media Query
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { colors, shadows } from "../../theme/designTokens";

export default function GoToTopButton() {
  const [visible, setVisible] = useState(false);

  // Responsive
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  window.addEventListener("scroll", toggleVisible);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <Grid
      container
      spacing={0}
      justifyContent="flex-end"
      sx={{ display: smUp ? "block" : "none" }}
    >
      <Grid item xs={2}>
        <Tooltip arrow placement="top" title={translateFront("Go To Top")}>
          <IconButton
            size="small"
            sx={{
              position: "fixed",
              bottom: "10px",
              right: "10px",
              zIndex: 2,
              cursor: "pointer",
              display: visible ? "inline-flex" : "none",
              width: 40,
              height: 40,
              bgcolor: colors.primaryDark,
              color: colors.white,
              boxShadow: shadows.card,
              "&:hover": { bgcolor: colors.primary },
            }}
            onClick={scrollToTop}
          >
            <KeyboardArrowUpIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
}
